module.exports = __webpack_public_path__ + "static/media/Artikal1.0bbd74a2.png";